import { AssessmentResultRecordType } from "../types";

export default function getStudentName(assessment: AssessmentResultRecordType) {
  return assessment.student.name;
}
